import SectionHeading from '@/components/feature/SectionHeading';
import { updateFeed } from '@/mocks/updates';

const toneClass: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800',
  secondary: 'bg-secondary-100 text-secondary-900',
  accent: 'bg-accent-100 text-accent-900',
};

export default function UpdateFeed() {
  return (
    <section id="updates" className="w-full bg-background-50 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="更新速递"
            title="今日更新速递"
            description="按整理时间由近到远排列，列出最近上线或更新的条目、类型、进度与一句话看点。"
          />
          <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
            <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 flex items-center gap-2">
              <i className="ri-information-line text-primary-600" aria-hidden="true"></i>
              关于更新节奏
            </h3>
            <ul className="mt-3 space-y-2 text-xs md:text-sm text-foreground-700 leading-relaxed">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-secondary-500 mt-0.5 shrink-0" aria-hidden="true"></i>
                电影以正片上线为准，同步记录片长与看点。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-secondary-500 mt-0.5 shrink-0" aria-hidden="true"></i>
                剧集、动漫按各自周期记录当前集数。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line text-secondary-500 mt-0.5 shrink-0" aria-hidden="true"></i>
                综艺与纪实按期次记录，篇幅较长但批次少。
              </li>
            </ul>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ul className="rounded-lg border border-background-200 overflow-hidden divide-y divide-background-200 bg-background-50">
            {updateFeed.map((item) => (
              <li key={item.id} className="p-4 md:p-5 hover:bg-background-100 transition-colors">
                <div className="flex flex-wrap items-center gap-2 md:gap-3">
                  <span className={`text-xs px-2.5 py-1 rounded-full ${toneClass[item.tone] ?? toneClass.primary}`}>
                    {item.category}
                  </span>
                  <h3 className="text-sm md:text-base font-bold text-foreground-950">{item.title}</h3>
                  <span className="text-xs md:text-sm text-primary-700 font-medium">{item.progress}</span>
                  <span className="ml-auto text-[11px] md:text-xs text-foreground-500 whitespace-nowrap">
                    <i className="ri-time-line mr-1" aria-hidden="true"></i>
                    {item.time}
                  </span>
                </div>
                <p className="mt-2 text-xs md:text-sm text-foreground-700 leading-relaxed">{item.detail}</p>
              </li>
            ))}
          </ul>
          <p className="mt-3 text-xs text-foreground-500">
            以上为最近一批整理结果，新的条目会按同一格式继续追加。
          </p>
        </div>
      </div>
    </section>
  );
}